import React from 'react'

import { Dropdown } from 'components/shared/Dropdown/Dropdown'
import CheckIcon from 'assets/icons/check-icon-dark.svg'

import { getLanguages } from 'utils/languages'

import styles from './LanguageSwitchMenu.module.scss'

type Language = ReturnType<typeof getLanguages>[number]

type LanguageSwitchMenuProps = {
  language?: string
  languages?: Language[]
  onSwitchLanguage?: (language: { code?: string }) => void
}

export const LanguageSwitchMenu = ({
  language,
  languages = [],
  onSwitchLanguage,
}: LanguageSwitchMenuProps) => (
  <Dropdown.Menu className={styles.menu}>
    {languages.map(({ roundIcon, original, value }) => (
      <Dropdown.MenuItem className={styles.item} key={value}>
        <Dropdown.Action onClick={() => onSwitchLanguage?.({ code: value })}>
          <img className={styles.flag} src={roundIcon} alt={value} />
          <span className={styles.name}>{original}</span>
          {language === value ? <img src={CheckIcon} alt={value} /> : null}
        </Dropdown.Action>
      </Dropdown.MenuItem>
    ))}
  </Dropdown.Menu>
)
